import { render, staticRenderFns } from "./DistrictFilter.vue?vue&type=template&id=371287e7&scoped=true&"
import script from "./DistrictFilter.vue?vue&type=script&lang=js&"
export * from "./DistrictFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371287e7",
  null
  
)

export default component.exports